export const COLORS = {
    primary: '#4485C6',
    primaryLight: '#82BDE7',
    primaryBg: '#80C9FF80',
    error: '#E64644',
    errorLight: '#F0929C',
    errorBg: '#FFA8A880',
    text: '#53545C',
    textSecondary: '#757575',
    white: '#FFFFFF',
    border: '#E1E2E9',
};

export const CARD_BASE_STYLE = {
    // Vertical only: the grid gap owns the space between columns, and a side
    // margin here would push each card out of the column it was given.
    margin: '10px 0',
    borderRadius: '15px',
    backgroundColor: '#FFFFFF',
    overflow: 'hidden',
};

export const CARD_DIMENSIONS = {
    small: {
        desktop: {
            // The grid column decides the width now; the card fills it and keeps
            // the square it had at its old 300x300, so a wider card gets taller
            // rather than flatter.
            width: '100%',
            minWidth: 0,
            aspectRatio: '1 / 1',
            // Floor at the height they used to have, so a narrow column makes a
            // card taller than square rather than shrinking it below its content.
            minHeight: '300px',
            display: 'flex',
            flexFlow: 'row wrap',
            justifyContent: 'center',
        },
        mobile: {
            width: '100%',
            minWidth: 'auto',
            height: 'auto',
            display: 'flex',
            flexFlow: 'column nowrap',
            justifyContent: 'flex-start',
        },
    },
    large: {
        desktop: {
            // Same idea at the 500x300 these started from.
            width: '100%',
            minWidth: 0,
            aspectRatio: '5 / 3',
            minHeight: '300px',
        },
        mobile: {
            width: '100%',
            minWidth: 'auto',
            height: 'auto',
        },
    },
};

export const TITLE_STYLES = {
    base: {
        width: '100%',
        color: '#53545C',
        fontSize: '20px',
        fontFamily: 'Roboto',
        fontWeight: '600',
        fontStyle: 'normal',
        textAlign: 'center',
    },
    withMargin: {
        margin: '10px 0px',
    },
    withTopMargin: {
        margin: '20px 0px 10px 0px',
    },
    mobile: {
        fontSize: '16px',
        margin: '12px 0px 6px 0px',
    },
};
